import {
  CAR_PREVIEW_RECEIVE_PREVIEW_MODEL,
  CAR_PREVIEW_SET_IS_CAR_PREVIEW_OPEN,
} from '../constants';
import { get } from '../Services/http';

export const setCarPreviewOpen = (isOpen) => ({
  type: CAR_PREVIEW_SET_IS_CAR_PREVIEW_OPEN,
  payload: {
    isOpen,
  },
});

export const loadCarPreviewModel = (
  carModelVariantSystemId,
  regNo,
  rimArticleNumber
) => (dispatch) => {
  return get(
    `api/carpreview?carModelVariantSystemId=${carModelVariantSystemId}&regNo=${regNo}&rimArticleNumber=${rimArticleNumber}`
  )
    .then((res) => res.json())
    .then((model) => dispatch(setCarPreviewModel(model)))
    .catch(() => dispatch(setCarPreviewModel({})));
};

export const setCarPreviewModel = (previewModel) => ({
  type: CAR_PREVIEW_RECEIVE_PREVIEW_MODEL,
  payload: {
    previewModel,
  },
});
